import React from 'react';

import Page from './page';

function NotFound() {
  return (
    <Page
      title="Page not found"
      description="We are sorry, but the page you are looking for does not exist"
      linkText={(
        <>
          Go to&nbsp;
          <strong>home page</strong>
        </>
    )}
    />
  );
}

export default NotFound;
